import { useCsrfToken } from '../use-csrf-token'

// this code has no test coverage. It's impossible to write acceptance tests against Stripe, and
// we could write unit tests here, but we have not. We should instead manually test this code extensively
// in the browser to ensure it works as expected.

/* global Stripe */

export function setupIntent() {
  const paymentFormElem = document.getElementById('payment-form')
  const options = {
    clientSecret: paymentFormElem.dataset.clientSecret,
    // Fully customizable with appearance API.
    appearance: {/*...*/}
  }

  const stripe = Stripe(paymentFormElem.dataset.stripeKey)
  const elements = stripe.elements(options)
  // Create and mount the Payment Element
  const paymentElement = elements.create('payment')
  paymentElement.mount('#payment-element')

  paymentFormElem.addEventListener('submit', async (event) => {
    event.preventDefault()

    const {error} = await stripe.confirmSetup({
      elements,
      confirmParams: {
        return_url: paymentFormElem.dataset.returnUrl
      }
    })

    if (error) {
      // This point will only be reached if there is an immediate error when
      // confirming the payment. Show error to your customer (for example, payment
      // details incomplete)
      const messageContainer = document.querySelector('#error-message')
      messageContainer.innerHTML = `<div class="notification error">${error.message}</div>`
    } else {
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
    }
  })
}

// Optional precondition gate. If the form declares
// data-require-checked-id="<checkbox-id>", submission is blocked until that
// checkbox is checked. Errors render into data-precondition-error-container.
// Runs in capture phase so it fires before setupIntent's submit handler.
export function preconditionGate() {
  const form = document.getElementById('payment-form')
  const checkboxId = form?.dataset.requireCheckedId
  if (!checkboxId) return

  const errorContainerId = form.dataset.preconditionErrorContainer
  const errorMessage = form.dataset.preconditionErrorMessage

  form.addEventListener('submit', (event) => {
    const errorContainer = errorContainerId && document.getElementById(errorContainerId)
    if (errorContainer) errorContainer.innerHTML = ''

    const checkbox = document.getElementById(checkboxId)
    if (!checkbox?.checked) {
      event.preventDefault()
      event.stopImmediatePropagation()
      if (errorContainer) {
        errorContainer.innerHTML = `<div class="notification error">${errorMessage}</div>`
      }
    }
  }, true)
}

// Terminal message on the verify page. The spinner sits in its own block above
// the status div, so it goes too — otherwise the page keeps claiming to work.
function showStatus(paymentStatusDiv, kind, message) {
  document.getElementById('payment-progress')?.remove()
  paymentStatusDiv.innerHTML = `<div class="notification ${kind}">${message}</div>`
}

export function verifyIntent() {
  const paymentStatusDiv = document.getElementById('payment-status')
  const stripe = Stripe(paymentStatusDiv.dataset.stripeKey)
  const confirmPath = paymentStatusDiv.dataset.confirmPath
  const successPath = paymentStatusDiv.dataset.successPath
  const retryPath = paymentStatusDiv.dataset.retryPath

  const clientSecret = new URLSearchParams(window.location.search).get(
    'setup_intent_client_secret'
  )

  stripe.retrieveSetupIntent(clientSecret).then(({setupIntent}) => {
    if (setupIntent.status === 'succeeded') {
      const csrfToken = useCsrfToken()

      fetch(confirmPath, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': csrfToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({setup_intent_id: setupIntent.id, stripe_payment_method_id: setupIntent.payment_method})
      }).then(response => {
        if (!response.ok) {
          throw response
        }
        response.text()
      }).then(() => {
        window.location.assign(successPath)
      }).catch(error => {
        console.error('error', error)
        if (retryPath) {
          showStatus(paymentStatusDiv, 'error', `We couldn't charge that payment method. <a href="${retryPath}">Try a different payment method</a>, or email hello@daisychain.app and we'll sort it out.`)
        } else {
          showStatus(paymentStatusDiv, 'error', 'We couldn\'t finish setting this up. Please email hello@daisychain.app and we\'ll sort it out.')
        }
      })
    } else if (setupIntent.status === 'processing') {
      // Handle processing state
      showStatus(paymentStatusDiv, 'info', 'Payment setup processing. Hold tight, we\'ll be in touch when your payment method is confirmed.')
    } else {
      // Handle unsuccessful or unknown payment status
      showStatus(paymentStatusDiv, 'error', 'Payment failed.')
    }
  })
}
